export const DocsService = {
    // Clonar una plantilla y reemplazar placeholders
    async createFromTemplate(templateId, folderId, fileName, replacements, accessToken) {
        try {
            // 1. Clonar el archivo en la carpeta del caso
            const copyResponse = await fetch(`https://www.googleapis.com/drive/v3/files/${templateId}/copy`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    name: fileName,
                    parents: [folderId]
                })
            });
            const newFile = await copyResponse.json();
            if (!copyResponse.ok) throw new Error(newFile.error?.message || 'Error clonando plantilla');

            // 2. Realizar batchUpdate para los reemplazos
            const requests = Object.entries(replacements).map(([key, value]) => ({
                replaceAllText: {
                    containsText: { text: `{{${key}}}`, matchCase: true },
                    replaceText: value
                }
            }));

            const updateResponse = await fetch(`https://www.googleapis.com/v1/documents/${newFile.id}:batchUpdate`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ requests })
            });

            if (!updateResponse.ok) {
                const error = await updateResponse.json();
                throw new Error(error.error?.message || 'Error procesando documento');
            }

            return { id: newFile.id, link: `https://docs.google.com/document/d/${newFile.id}/edit` };
        } catch (error) {
            console.error("Docs Service Error:", error);
            throw error;
        }
    }
};
